module.exports = __webpack_public_path__ + "static/media/partner8.fbdd9ff8.png";